exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".header--description[data-v-7d79891e]{color:#706c69;font-size:14px;padding:10px;border:1px solid #ede8e4;float:left;margin-bottom:30px;display:block;clear:both;position:absolute;top:15px;right:30px;width:50%}@media (max-width:992px){.header--description[data-v-7d79891e]{position:relative;top:0;right:0;width:100%}.header--description[data-v-7d79891e]:after,.header--description[data-v-7d79891e]:before{display:none}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7d79891e","scoped":true,"hasInlineConfig":true}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/modals/main-survey/survey-step1-q1.vue
// module id = 860
// module chunks = 0